<template>
  <div>
    <div class="row mb-5">
      <span class="display-4 col-12">
        {{ `${warehouse.name}` }} -
        {{ $t("COMMON.LOGS") }}
      </span>
    </div>

    <log-list-table :filterSubject="warehouse" />
  </div>
</template>
<script>
import LogListTable from "@/views/Pages/DefaultModule/LogManagement/partials/LogListTable.vue";

export default {
  name: "warehouse-view-logs",

  components: { LogListTable },

  props: ["warehouse"],

  mixins: [],

  data() {
    return {};
  },

  computed: {},

  methods: {},

  mounted() {},

  watch: {
    user(user) {},
  },
};
</script>
